export const normalizePath = (path: string) => (path.startsWith('/')
  ? `${process.env.VUE_APP_API_URL}${path}`
  : path);
